import { Panel } from '@app/components/common/Collapse/Collapse';
import { IDealRoomSectionContent, IDealRoomShare } from '@app/interfaces/deal-room';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PodcastType } from '@app/api/podcast.api';
import { ListenToOurPodcast } from './ListenToOurPodcast';
import * as S from '../../DealRoomLanding.styles';
import { useSubMenuMouseflow } from '@app/hooks/useSubMenuMouseflow';
import { scrollToSection } from '@app/utils/scrollToSection';

interface ListenToOurPodcastsProps {
  section: IDealRoomSectionContent;
  dealRoom?: IDealRoomShare;
}

export const ListenToOurPodcasts: React.FC<ListenToOurPodcastsProps> = ({ section, dealRoom }) => {
  const { t } = useTranslation();
  const [activeKey, setActiveKey] = useState<string>('');

  useSubMenuMouseflow(activeKey, (key) => {
    const sub = section.subMenu?.find((s) => s.key === key);
    return sub?.label || t(sub?.labelKey || key);
  });

  useEffect(() => {
    const handleHashChange = () => {
      if (window.location.hash) {
        const hashKey = window.location.hash.replace('#', '');
        const subMatch = section.subMenu?.find((subSection) => subSection.key === hashKey);
        if (subMatch) {
          setActiveKey(subMatch.key);
        }
      }
    };

    handleHashChange();
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, [section.subMenu]);

  useEffect(() => {
    setTimeout(() => scrollToSection(activeKey), 400);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeKey]);

  if (!section.subMenu || section.subMenu.length === 0) {
    return <ListenToOurPodcast dealRoom={dealRoom} />;
  }

  return (
    <S.ChildContainer className="child-container">
      <S.ChildCollapse accordion activeKey={activeKey} onChange={(key) => setActiveKey(key as string)}>
        {section.subMenu.map((subSection) => (
          <Panel
            id={subSection.key}
            header={subSection.label ? subSection.label : t(subSection.labelKey)}
            key={subSection.key}
          >
            <ListenToOurPodcast type={subSection.key as PodcastType} dealRoom={dealRoom} />
          </Panel>
        ))}
      </S.ChildCollapse>
    </S.ChildContainer>
  );
};
